<template>
    <div class="font-vectrex text-5xl md:text-9xl text-center">
        <div id="anar" class="-mb-4 tracking-wider h-[70px] md:h-[150px] flex items-center justify-center">
            ANAR
        </div>
        <AtomSectionSeparator class="absolute left-0"/>
        <div id="chive" class="md:mt-6 chive h-[70px] md:h-[150px] flex items-center justify-center">
            CHIVE
        </div>
    </div>

</template>

<script>
import AtomSectionSeparator from "../atoms/AtomSectionSeparator.vue";

export default {
    name: "MoleculeAnarchiveTitle",
    components: {AtomSectionSeparator}
}
</script>

<style lang="scss" scoped>
#anar {
    -webkit-mask-image: linear-gradient(0deg, transparent 25px, red 75px);
    @media (min-width: 768px) {
        & {
            -webkit-mask-image: linear-gradient(0deg, transparent 50px, red 160px);
        }
    }
}

#chive {
    -webkit-mask-image: linear-gradient(180deg, transparent 11px, red 75px);
    @media (min-width: 768px) {
        & {
            -webkit-mask-image: linear-gradient(180deg, transparent 4px, red 140px);
        }
    }
}
</style>

